import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SizeForm from "./SizeForm";
import { addSize } from "../../../api/sizeService";
import { getErrorMessage } from "../../../utils/errorHandler";

export default function AddSize() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [backendErrors, setBackendErrors] = useState({});

  const handleSubmit = async (formData) => {
    console.log("Submitting:", formData);
    try {
      setLoading(true);
      const response = await addSize(formData);
      console.log("resp:", response);
      setMessage(response?.message || "Size added successfully");
      if (response?.success === false || response?.status === 422) {
        setBackendErrors(response?.error || {});
        return;
      }
      setTimeout(() => {
        navigate("/size");
      }, 1500);
    } catch (error) {
      console.error(error);
      setMessage(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="card p-4">
        
        {message && <div className="alert alert-success">{message}</div>}
        <SizeForm
          onSubmit={handleSubmit}
          loading={loading}
          backendErrors={backendErrors}
          buttonText="Add Size"
        />
      </div>
    </div>
  );
}
